import { Validator } from '@vista-digital/validator';
/**
 * Note: The min value is set to -1 and the max value is set to 101 due to incorrect data from the API.
 * It is possible for a top value to be a negative value e.g. -0.03 or the height + top of an area to be larger than 100 by a fractional number e.g. 100.08.
 * This is a temporary solution until data can be fixed at the source, it does not fix any rendering issue due to bad data.
 */
export const seatLayoutGridUnitValidator = Validator.number({ min: -1, max: 101 });
